import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import '../../utils/getClientInfo/getClientInfo.mjs';
import '../../utils/retry/retry.mjs';
import '@aws-crypto/sha256-js';
import '@smithy/util-hex-encoding';
import { parseMetadata } from '../../clients/serde/responseInfo.mjs';
import { parseJsonError, parseJsonBody } from '../../clients/serde/json.mjs';
import { composeServiceApi } from '../../clients/internal/composeServiceApi.mjs';
import { defaultConfig, cognitoIdentityTransferHandler, buildHttpRpcRequest, getSharedHeaders } from './base.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var getCredentialsForIdentitySerializer = function getCredentialsForIdentitySerializer(input, endpoint) {
  var headers = getSharedHeaders('GetCredentialsForIdentity');
  var body = JSON.stringify(input);
  return buildHttpRpcRequest(endpoint, headers, body);
};

var getCredentialsForIdentityDeserializer = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var error, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(response.statusCode >= 300)) {
              _context.next = 7;
              break;
            }

            _context.next = 3;
            return parseJsonError(response);

          case 3:
            error = _context.sent;
            throw error;

          case 7:
            _context.next = 9;
            return parseJsonBody(response);

          case 9:
            body = _context.sent;
            return _context.abrupt("return", {
              IdentityId: body.IdentityId,
              Credentials: deserializeCredentials(body.Credentials),
              $metadata: parseMetadata(response)
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCredentialsForIdentityDeserializer(_x) {
    return _ref.apply(this, arguments);
  };
}();

var deserializeCredentials = function deserializeCredentials() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      AccessKeyId = _ref2.AccessKeyId,
      SecretKey = _ref2.SecretKey,
      SessionToken = _ref2.SessionToken,
      Expiration = _ref2.Expiration;

  return {
    AccessKeyId: AccessKeyId,
    SecretKey: SecretKey,
    SessionToken: SessionToken,
    Expiration: Expiration && new Date(Expiration * 1000)
  };
};
/**
 * @internal
 */


var getCredentialsForIdentity = composeServiceApi(cognitoIdentityTransferHandler, getCredentialsForIdentitySerializer, getCredentialsForIdentityDeserializer, defaultConfig);
export { getCredentialsForIdentity };